var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Asterisk } from '@marketing/components/funnel/Icons/Icons';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import AddressInput from '@marketing/profile/common/AddressInput';
import PhoneInput from '@marketing/profile/common/PhoneInput';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import { trackAddressStart, trackCompleteAddress } from '@marketing/profile/trackers';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { validateAllAddressValues } from '@utils/form_validations';
import { formatPhone } from '@utils/formatting_utils';
var AddressForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), profileData = _a.profileData, profileBasePath = _a.profileBasePath, saveProfile = _a.saveProfile, sendFunnelGTMEvent = _a.sendFunnelGTMEvent;
    var _b = useState(profileData.apt || ''), apt = _b[0], setApt = _b[1];
    var _c = useState(profileData.city || ''), city = _c[0], setCity = _c[1];
    var _d = useState(profileData.state || ''), state = _d[0], setState = _d[1];
    var _e = useState(profileData.zipcode || ''), zipcode = _e[0], setZipcode = _e[1];
    var _f = useState(profileData.street || ''), street = _f[0], setStreet = _f[1];
    var _g = useState(formatPhone(profileData.phone) || ''), phone = _g[0], setPhone = _g[1];
    var _h = useState(profileData.smsOptIn || false), smsOptIn = _h[0], setSmsOptIn = _h[1];
    var _j = useState(function () {
        var isValidAddressMap = validateAllAddressValues(street, city, state, zipcode, phone);
        return Object.values(isValidAddressMap).every(function (value) { return value; });
    }), isValid = _j[0], setIsValid = _j[1];
    useEffect(function () {
        trackAddressStart();
    }, []);
    useEffect(function () {
        var isValidAddressMap = validateAllAddressValues(street, city, state, zipcode, phone);
        setIsValid(Object.values(isValidAddressMap).every(function (value) { return value; }));
    }, [street, city, state, zipcode, phone]);
    var handleStreetChange = function (value) {
        setStreet(value);
    };
    var handleAddressSelected = function (addressObj) {
        var apt = addressObj.apt, city = addressObj.city, state = addressObj.state, street = addressObj.street, zipcode = addressObj.zipcode;
        setApt(apt);
        setCity(city);
        setState(state);
        setStreet(street);
        setZipcode(zipcode);
    };
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/contact"), { viewTransition: true });
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!isValid) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveProfile({ apt: apt, city: city, state: state, street: street, zipcode: zipcode, phone: phone, smsOptIn: smsOptIn })];
                case 2:
                    data = _a.sent();
                    trackCompleteAddress(data);
                    sendFunnelGTMEvent('click-next_address', {
                        customerName: data.customerName,
                        email: data.email,
                        hashedEmail: data.hashedEmail,
                        street: data.street,
                        apt: data.apt,
                        city: data.city,
                        state: data.state,
                        zipcode: data.zipcode,
                    });
                    navigate("".concat(profileBasePath, "/summary"), { viewTransition: true });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error saving profile:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var formId = 'address-form';
    return (_jsx(ProfileFormLayout, __assign({ disableNext: !city || !state || !street || !zipcode || !phone || !isValid, formId: formId, handleClickPrevious: handleClickPrevious }, { children: _jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Delivery Address" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-16" }, { children: [_jsxs("div", __assign({ className: "text-center grid grid-cols-1 gap-8" }, { children: [_jsx("h2", __assign({ className: "font-medium" }, { children: "Delivery Address" })), _jsx("p", { children: "We cannot ship to P.O. boxes, HI, or AK." }), _jsxs("div", { children: [_jsx("span", __assign({ className: "inline-block mr-2" }, { children: _jsx(Asterisk, {}) })), _jsx("span", __assign({ className: "inline-block" }, { children: "= required fields" }))] })] })), _jsxs("form", __assign({ id: formId, onSubmit: handleSubmit, className: "w-full grid grid-cols-1 gap-8" }, { children: [_jsx(AddressInput, { apt: apt, city: city, state: state, street: street, zipcode: zipcode, handleAddressSelected: handleAddressSelected, handleStreetChange: handleStreetChange, setApt: setApt, setCity: setCity, setState: setState, setStreet: setStreet, setZipcode: setZipcode, setIsValid: setIsValid }), _jsx(PhoneInput, { phone: phone, setPhone: setPhone, smsOptIn: smsOptIn, setSmsOptIn: setSmsOptIn, setIsValid: setIsValid })] }))] })) })) })));
};
export default AddressForm;
